import { render, staticRenderFns } from "./TopCompany3.vue?vue&type=template&id=21b4479f&scoped=true&"
import script from "./TopCompany3.vue?vue&type=script&lang=js&"
export * from "./TopCompany3.vue?vue&type=script&lang=js&"
import style0 from "./TopCompany3.vue?vue&type=style&index=0&id=21b4479f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b4479f",
  null
  
)

export default component.exports